import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function LicensingPage() {
  const pa = usePracticeArea('licensing');
  return <PracticeAreaTemplate pa={pa} />;
}
